<cdk-virtual-scroll-viewport
  #scrollViewport
  itemSize="500"
  class="flex-grow overflow-y-auto"
  (scroll)="onScroll($event)"
>
  <phoenix-conversation-miniature
    [data]="_selectedConversation"
    [miniatureFormat]="false"
    (downloadConversation)="downloadConversationSync()"
    [showDownloadButton]="
      userHasPermissionToExport &&
      (['DIRECT_COLLECT_EXPORT'] | permissions | async)
    "
    [options]="options"
    (changeViewOption)="changeViewOption($event)"
    [showHighlightButton]="showHighlightButton"
    (scrollToHighlight)="scrollToFirstHighlight()"
    [translationsEnabled]="hasTranslations(messageCollection)"
  ></phoenix-conversation-miniature>

  @if (firstConversation && directService.itemLoading$()) {
    <div class="flex h-screen items-center justify-center">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    @if (messageCollection.length > 0) {
      @if (directService.itemLoading$()) {
        <mat-progress-bar
          mode="indeterminate"
          class="w-full"
        ></mat-progress-bar>
      }
      <div class="px-2">
        @if (conversationBefore !== '') {
          <div class="text-center">
            <button
              class="w-full"
              mat-button
              color="primary"
              type="button"
              [attr.aria-label]="'timeline-messages-load-previous'"
              [disabled]="directService.itemLoading$()"
              (click)="loadBefore()"
            >
              <span class="font-semibold">Load previous messages</span>
            </button>
          </div>
        }

        @for (
          msg of messageCollection;
          track msg.id;
          let first = $first;
          let i = $index
        ) {
          <div>
            @if (
              first || (msg | checkConversationDate: messageCollection[i - 1])
            ) {
              <div class="w-full text-center">
                <span class="theme-text-1">
                  {{ msg?.eventTime | date: 'mediumDate' : 'UTC' }}
                </span>
              </div>
            }

            @if (
              first ||
              (msg | checkConversationMember: messageCollection[i - 1]) ||
              (msg | checkConversationDate: messageCollection[i - 1])
            ) {
              <div
                [ngStyle]="{
                  color: actorsColors[msg?.message?.from?.toLowerCase() ?? ''],
                }"
              >
                <span class="hover:underline">
                  {{ msg?.message?.from }}
                </span>
              </div>
            }

            <div
              (click)="
                isMessageCorrupted(msg)
                  ? $event.stopPropagation()
                  : openDialog(msg)
              "
              (keyup)="(null)"
              class="{{
                !directService.itemLoading$() && !isMessageCorrupted(msg)
                  ? 'cursor-pointer'
                  : 'cursor-not-allowed'
              }} theme-bg-1--hover rounded-sm timeline-messages-detail"
              [ngClass]="{
                'opacity-50 grayscale': isMessageCorrupted(msg),
              }"
              [matTooltip]="
                isMessageCorrupted(msg) ? 'Corrupted information' : ''
              "
            >
              <div class="flex flex-row">
                <div
                  class="whitespace-nowrap theme-text-1 text-xs py-[4px] pr-[5px]"
                  [ngClass]="{
                    'timeline-messages-detail__hidden':
                      !first &&
                      (msg | messageHiddenTime: messageCollection[i - 1]),
                  }"
                >
                  {{ msg?.eventTime | date: 'shortTime' : 'UTC' }}
                </div>

                <div class="w-full flex flex-col items-center justify-center">
                  @if (msg?.message?.text) {
                    <div
                      #highlightContainer
                      class="whitespace-pre-line timeline-messages-detail__break-words text-sm timeline-detail-messages-view w-full"
                      [innerHTML]="
                        directService.showTranslations$() && msg?.translation
                          ? truncateMessage(msg?.translation)
                          : truncateMessage(msg?.message?.text)
                      "
                    ></div>
                  }

                  @if (msg?.attachments && msg.attachments.length !== 0) {
                    <phoenix-message-attachment
                      class="w-full"
                      [attachments]="msg.attachments"
                    ></phoenix-message-attachment>
                  }
                </div>
              </div>
            </div>
          </div>
        }

        @if (conversationAfter !== '' && !isScrollActive) {
          <div class="text-center">
            <button
              class="w-full"
              type="button"
              [attr.aria-label]="'timeline-messages-load-more'"
              mat-button
              color="primary"
              [disabled]="directService.itemLoading$()"
              (click)="loadConversation()"
            >
              <span class="font-semibold">Load more messages</span>
            </button>
          </div>
        }
        @if (directService.itemLoading$()) {
          <mat-progress-bar
            mode="indeterminate"
            class="w-full bottom-4 timeline-messages-detail__bottom-progress-bar"
          ></mat-progress-bar>
        }
      </div>
    } @else {
      <phoenix-no-data></phoenix-no-data>
    }
  }
</cdk-virtual-scroll-viewport>

<ng-template #templateMessage>
  <phoenix-timeline-message-detail
    [selectedId]="selectedMessage.id"
    [actorsColors]="actorsColors"
    [heightLimit]="false"
  ></phoenix-timeline-message-detail>
</ng-template>

<ng-template #largeExportDialogForm>
  <form [formGroup]="confirmLargeExportForm" class="overflow-hidden">
    <div class="flex flex-col gap-3">
      <p class="text-sm flex flex-row text-orange-600 items-start">
        <mat-icon class="mr-2 scale-90 flex-shrink-0">warning</mat-icon>
        <span
          >You're exporting over {{ getFormattedThreshold() }} results. This may
          create a large file, and the download could take several minutes to
          complete.</span
        >
      </p>
      <mat-checkbox
        formControlName="confirmLargeExport"
        class="text-sm"
        aria-label="large-export-confirmation"
      >
        I understand and want to proceed.
      </mat-checkbox>
    </div>
  </form>
</ng-template>
